// extracted by mini-css-extract-plugin
export default {"container":"zC4jNJ","text":"nG5hH_","block":"JyVnOJ"};